import React from "react";

import { useSelector } from "react-redux";

 const ActorDetailHeader = ({
    actorType,
    title,
    isExpanded
 }) => {
 const name = useSelector((state) => state.Actor[actorType]?.name || "");
   
    return (
       <div>
           {`${isExpanded ? title : `${title} : ${name}`}`}
   
       </div>
     );
  
}


export default ActorDetailHeader
